export const reservationsSummarySelector = (period: string) => (state: any) => state.reservationsSummary.data; 